import { Box, InputCheckBox, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { AutoScheduleForm } from 'modules/shift_management/lib/forms/AutoScheduleForm'

interface Props {
  form: AutoScheduleForm
}
const Rules = observer(({ form }: Props) => {
  const handleCheck = (rule: string) => {
    const currentField = form.get(rule)
    currentField.set(!currentField.value)
  }

  const AutomaticScheduleRules = {
    AGREEMENT_HOURS: {
      key: 'agreement_hours',
      label: i18n.t('shift_management.coverage_section.automation.modal.rules.agreement_hours'),
    },
    REST_DAYS_PER_WEEK: {
      key: 'rest_days_per_week',
      label: i18n.t('shift_management.coverage_section.automation.modal.rules.rest_days_per_week'),
    },
    MIN_REST_HOURS_BETWEEN_SHIFTS: {
      key: 'rest_hours_between_shifts',
      label: i18n.t('shift_management.coverage_section.automation.modal.rules.min_rest_hours'),
    },
    MAX_WORK_HOURS_PER_DAY: {
      key: 'max_work_hours_per_day',
      label: i18n.t('shift_management.coverage_section.automation.modal.rules.max_work_hours'),
    },
  } as const

  return (
    <Box gap="s8" flexDirection="column">
      <Text.Header3>
        {i18n.t('shift_management.coverage_section.automation.modal.rules.title')}
      </Text.Header3>

      {Object.entries(AutomaticScheduleRules).map(([idx, rule]) => (
        <Box key={idx} gap="s12" flexDirection="row">
          <InputCheckBox checked={form.get(rule.key).value} onClick={() => handleCheck(rule.key)} />
          {rule.label}
        </Box>
      ))}
    </Box>
  )
})

export { Rules }
